import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/life-general-types/life/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchLifeTenantsNoSuspense =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useQuery
